/*
 * 通用消息提示：pc用的是message形式，m站用的是toast形式
 * */
const AcspToast = {};

const defaultOptions = {
  type: "text", // 提示类型：text/success/notice/loading
  message: "", // 提示文本
  duration: 2, // 默认自动关闭延时，单位秒
};

/**
 * 只展示文本
 */
AcspToast.showText = (message) => {
  AcspToast.show({ message, type: "text" });
};

/**
 * 成功提示
 */
AcspToast.showSuccess = (message) => {
  AcspToast.show({ message, type: "success" });
};

/**
 * 错误、警告提示
 */
AcspToast.showNotice = (message) => {
  AcspToast.show({ message, type: "notice" });
};

/**
 * 加载中
 */
AcspToast.showLoading = (message) => {
  AcspToast.show({ message, type: "loading" });
};

/**
 * 关闭toast
 */
AcspToast.close = () => {
  showInstance && showInstance.close && showInstance.close();
};

/**
 * 显示信息
 * @param options 默认=defaultOptions
 */
AcspToast.show = (options) => {
  showInstance &&
    showInstance.show &&
    showInstance.show({ ...defaultOptions, ...options });
};

/**
 * 配置vant-ui的toast
 * @param vantToast
 */
AcspToast.configVant = (vantToast) => {
  showInstance.show = (options) => {
    let {
      message, // 提示文本
      duration, // 默认自动关闭延时，单位秒
      type, // 提示类型：text/success/notice
    } = options || {};

    duration = duration * 1000;
    if (type === "success") {
      vantToast.success({ message, duration });
    } else if (type === "notice") {
      vantToast.fail({ message, duration });
    } else if (type === "loading") {
      vantToast.loading({
        message,
        duration: 0, // 展示时长(ms)，值为 0 时，toast 不会消失
        forbidClick: true,
      });
    } else {
      vantToast({ message, duration });
    }
  };
  showInstance.close = () => {
    vantToast.clear();
  };
};

/**
 * 具体显示的的第三方插件
 * @type {{show: showInstance.show}}
 */
export const showInstance = {
  show: (options) => {},
  close: () => {},
};

export default AcspToast;
